export var NotificationType;
(function (NotificationType) {
    // Notes mentions
    /** Note on a invoice */
    NotificationType["INVOICE_NOTE_MENTION"] = "invoice_note_mention";
    /** Note on a contact */
    NotificationType["CONTACT_NOTE_MENTION"] = "contact_note_mention";
    /* Note on an escalation */
    NotificationType["ESCALATION_NOTE_MENTION"] = "escalation_note_mention";
    /** Note on a quote */
    NotificationType["QUOTE_NOTE_MENTION"] = "quote_note_mention";
    /** Note in an AI conversation */
    NotificationType["CONVERSATION_NOTE_MENTION"] = "conversation_note_mention";
    // Assignments
    /** Invoice assignment */
    NotificationType["INVOICE_ASSIGNMENT"] = "invoice_assignment";
    /** Contact assignment */
    NotificationType["CONTACT_ASSIGNMENT"] = "contact_assignment";
    /** Escalation assignment */
    NotificationType["ESCALATION_ASSIGNMENT"] = "escalation_assignment";
    /** Quote assignment */
    NotificationType["QUOTE_ASSIGNMENT"] = "quote_assignment";
    // Payment promises
    /** A payment promise was broken */
    NotificationType["PROMISE_BROKEN"] = "promise_broken";
    // Queries
    /** A customer or the AI agent opened a query */
    NotificationType["QUERY_OPENED"] = "query_opened";
    /** An open query passed its due date */
    NotificationType["QUERY_OVERDUE"] = "query_overdue";
})(NotificationType || (NotificationType = {}));
export const assignmentTypes = [
    NotificationType.INVOICE_ASSIGNMENT,
    NotificationType.CONTACT_ASSIGNMENT,
    NotificationType.ESCALATION_ASSIGNMENT,
    NotificationType.QUOTE_ASSIGNMENT,
];
export const mentionTypes = [
    NotificationType.INVOICE_NOTE_MENTION,
    NotificationType.CONTACT_NOTE_MENTION,
    NotificationType.ESCALATION_NOTE_MENTION,
    NotificationType.QUOTE_NOTE_MENTION,
    NotificationType.CONVERSATION_NOTE_MENTION,
];
//# sourceMappingURL=notification.js.map